import React from 'react';
import { ActivityPost } from '@components/feed/Feed/components/ActivityPost';
import { ICompetitionStoppedActivity } from './interfaces';
import { Trans } from 'react-i18next';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { CompetitionActivityBody } from '../components/CompetitionActivityBody';

export const CompetitionStoppedActivity: React.FC<
  ICompetitionStoppedActivity
> = (props): JSX.Element => {
  const activityTitle = (
    <Trans
      i18nKey={'activities:competitionStopped.title'}
      values={{
        title: props.title,
      }}
      components={{
        bold: <strong />,
      }}
    />
  );

  return (
    <ActivityPost
      title={activityTitle}
      date={props.date}
      icon={VisibilityOffIcon}
    >
      <CompetitionActivityBody {...props} variant="stopped" />
    </ActivityPost>
  );
};
